import React, { Component } from 'react';
import { connect } from 'react-redux';
import './ProjectRfiLog.css';
import printWhiteSvg from 'images/print-white.svg';
import Button from 'components/shared/button/Button';
import NavigationBar from 'components/shared/navigation/NavigationBar';
import PdfViewer from 'components/shared/pdf-viewer/PdfViewer';
import { Enterprise } from 'domain/enterprise';
import { getCurrentUser } from 'selectors/authentication';
import { getCurrentProject } from 'components/admin/projects/details/store/selectors';
import { getNotifications } from 'selectors/notifications';
import { unreadNotifications } from 'domain/notification';
import { markNotifiableNotificationsAsRead } from 'actions/notifications';
import {
  initRfiLog,
  loadRfisRequest,
  setRfiTabSelected,
  setRfiModalShow,
  openRfi,
  setRfiLogPdfViewer,
  loadRfiLogPdfRequest,
} from 'components/admin/projects/details/project-rfi-log/store/actions';
import {
  getRfis,
  getTotal,
  getCurrentPage,
  getCurrentStatus,
  getDueDateFilter,
  getPageSize,
  getRfiTabSelected,
  getCurrentRfi,
  getRfiLogPdfViewer,
  getRfiLogPdf,
} from 'components/admin/projects/details/project-rfi-log/store/selectors';
import RfiLogTable from 'components/admin/projects/details/project-rfi-log/RfiLogTable';
import RfiModalContainer from 'components/admin/projects/details/project-rfi-log/RfiModalContainer';

class ProjectRfiLog extends Component {
  constructor(props) {
    super(props);

    props.dispatch(initRfiLog());
  }

  componentDidMount() {
    if (this.props.currentProject) {
      this.handlePageChange(1, this.defaultStatus());
    }
  }

  handleRfiTabSelection = (rfiTab) => {
    this.handlePageChange(1, this.defaultStatus(rfiTab));
    this.props.dispatch(setRfiTabSelected(rfiTab));
  };

  handlePageChange = (page, status, dueDateFilter) => {
    const { currentProject, dispatch } = this.props;
    dispatch(loadRfisRequest(currentProject.id, page, status, dueDateFilter));
  };

  showPreRfi = (contribType) => {
    return Enterprise.spackleOrGc(contribType);
  };

  defaultStatus = (rfiTab = 2) => {
    const { currentProject } = this.props;
    const showPreRfi = !!this.showPreRfi(currentProject.contributor_type);
    return (showPreRfi && (rfiTab === 1 ? 'pending' : 'not_pre')) || 'all';
  };

  handleOpenRfiModal = () => {
    this.props.dispatch(setRfiModalShow(true));
  };

  handleOpenRfi = (id, readOnly = false) => {
    const { currentProject, dispatch } = this.props;
    dispatch(openRfi(currentProject.id, id, readOnly));
    dispatch(markNotifiableNotificationsAsRead(id, 'Rfi'));
  };

  handleViewRfiLogPdf = () => {
    const { currentProject, dispatch, rfiTabSelected } = this.props;
    dispatch(
      loadRfiLogPdfRequest(
        currentProject.id,
        this.defaultStatus(rfiTabSelected)
      )
    ).then((response) => {
      if (response.ok) {
        dispatch(setRfiLogPdfViewer(true));
      }
    });
  };

  handleRfiLogPdfViewerClose = () => {
    this.props.dispatch(setRfiLogPdfViewer(false));
  };

  render() {
    const currentUser = this.props.currentUser;
    const contribType =
      this.props.currentProject && this.props.currentProject.contributor_type;
    const unreadById = unreadNotifications(this.props.notifications, 'Rfi');
    const {
      rfis,
      total,
      currentPage,
      currentStatus,
      pageSize,
      rfiTabSelected,
      rfiLogPdfViewer,
      rfiLogPdf,
      dueDateFilter,
    } = this.props;
    return (
      this.props.currentProject && (
        <div className="rfi-log">
          <div className="rfi-log-header">
            <NavigationBar
              items={[
                {
                  id: 1,
                  title: 'P-RFI LOG',
                  show: this.showPreRfi(contribType),
                  class: rfiTabSelected === 1 ? 'sel' : '',
                },
                {
                  id: 2,
                  title: 'RFI LOG',
                  class: rfiTabSelected === 2 ? 'sel' : '',
                },
              ]}
              onSelected={this.handleRfiTabSelection}
            />
            <div className="buttons-container">
              <Button
                className="button-gray"
                icon={printWhiteSvg}
                label="View PDF"
                onClick={this.handleViewRfiLogPdf}
              />
              {!Enterprise.primary(contribType) && (
                <Button
                  className="button-orange"
                  label="Add New RFI"
                  onClick={this.handleOpenRfiModal}
                />
              )}
            </div>
          </div>

          {/*Navigation bar items content*/}
          <RfiLogTable
            rfis={rfis}
            total={total}
            currentPage={currentPage}
            currentStatus={currentStatus}
            dueDateFilter={dueDateFilter}
            pageSize={pageSize}
            currentUser={currentUser}
            contribType={contribType}
            unreadById={unreadById}
            rfiTabSelected={rfiTabSelected}
            handlePageChange={this.handlePageChange}
            handleOpenRfi={this.handleOpenRfi}
          />

          {rfiLogPdfViewer && (
            <PdfViewer
              content={{
                source: rfiLogPdf,
                type: 'blob',
              }}
              show={rfiLogPdfViewer}
              onClose={this.handleRfiLogPdfViewerClose}
            />
          )}

          <RfiModalContainer />
        </div>
      )
    );
  }
}

export default connect((state) => {
  return {
    currentUser: getCurrentUser(state),
    currentProject: getCurrentProject(state),
    rfis: getRfis(state),
    rfiTabSelected: getRfiTabSelected(state),
    currentRfi: getCurrentRfi(state),
    total: getTotal(state),
    currentPage: getCurrentPage(state),
    currentStatus: getCurrentStatus(state),
    dueDateFilter: getDueDateFilter(state),
    pageSize: getPageSize(state),
    notifications: getNotifications(state),
    rfiLogPdfViewer: getRfiLogPdfViewer(state),
    rfiLogPdf: getRfiLogPdf(state),
  };
})(ProjectRfiLog);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-rfi-log/ProjectRfiLog.js